var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinLogoBw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#linkedin-logo-bw_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.027 0C18.64 0 24 5.36 24 11.973v.054C24 18.64 18.64 24 12.027 24h-.054C5.36 24 0 18.64 0 12.027v-.054C0 5.36 5.36 0 11.973 0zM5.515 18.658h2.842V9.661H5.515zm9.822-9.117q-.875 0-1.572.34a2.87 2.87 0 0 0-1.112.93V9.637H9.937v8.863h2.716v-4.813q0-.89.461-1.381.46-.493 1.238-.493t1.239.493q.46.492.46 1.38V18.5h2.701v-5.178q0-1.763-.929-2.771-.929-1.01-2.486-1.009M6.945 5.343q-.747 0-1.221.44A1.47 1.47 0 0 0 5.25 6.89q0 .648.474 1.089c.316.293.734.44 1.221.44q.732 0 1.205-.44c.316-.294.473-.646.473-1.09q0-.664-.473-1.105c-.315-.293-.706-.44-1.205-.44"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linkedin-logo-bw_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgLinkedinLogoBw;